module.exports = __webpack_public_path__ + "static/media/eye-open.66501d2a.svg";